"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "routes", {
    enumerable: true,
    get: function() {
        return routes;
    }
});
const _types = require("./types");
const routes = (0, _types.buildRoutes)({
    settings: {
        path: "/settings"
    },
    records: {
        path: "/settings/account/records"
    },
    submissionsBuilderV2: {
        path: "/settings/account/records/submissions-builder-v2/:submissionTypeId?"
    },
    propertyData: {
        path: "/settings/account/property-data"
    },
    editSection: {
        path: "/settings/account/property-data/section/:sectionId"
    },
    usersSettings: {
        path: "/settings/users"
    },
    teamSettings: {
        path: "/settings/users/team"
    },
    publicUsersSettings: {
        path: "/settings/users/public"
    }
});

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3JvdXRpbmcvc2V0dGluZ3MudHMiXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgYnVpbGRSb3V0ZXMgfSBmcm9tIFwiLi90eXBlc1wiO1xuXG5leHBvcnQgY29uc3Qgcm91dGVzID0gYnVpbGRSb3V0ZXMoe1xuICBzZXR0aW5nczoge1xuICAgIHBhdGg6IFwiL3NldHRpbmdzXCIsXG4gIH0sXG4gIHJlY29yZHM6IHtcbiAgICBwYXRoOiBcIi9zZXR0aW5ncy9hY2NvdW50L3JlY29yZHNcIixcbiAgfSxcbiAgc3VibWlzc2lvbnNCdWlsZGVyVjI6IHtcbiAgICBwYXRoOiBcIi9zZXR0aW5ncy9hY2NvdW50L3JlY29yZHMvc3VibWlzc2lvbnMtYnVpbGRlci12Mi86c3VibWlzc2lvblR5cGVJZD9cIixcbiAgfSxcbiAgcHJvcGVydHlEYXRhOiB7XG4gICAgcGF0aDogXCIvc2V0dGluZ3MvYWNjb3VudC9wcm9wZXJ0eS1kYXRhXCIsXG4gIH0sXG4gIGVkaXRTZWN0aW9uOiB7XG4gICAgcGF0aDogXCIvc2V0dGluZ3MvYWNjb3VudC9wcm9wZXJ0eS1kYXRhL3NlY3Rpb24vOnNlY3Rpb25JZFwiLFxuICB9LFxuICB1c2Vyc1NldHRpbmdzOiB7XG4gICAgcGF0aDogXCIvc2V0dGluZ3MvdXNlcnNcIixcbiAgfSxcbiAgdGVhbVNldHRpbmdzOiB7XG4gICAgcGF0aDogXCIvc2V0dGluZ3MvdXNlcnMvdGVhbVwiLFxuICB9LFxuICBwdWJsaWNVc2Vyc1NldHRpbmdzOiB7XG4gICAgcGF0aDogXCIvc2V0dGluZ3MvdXNlcnMvcHVibGljXCIsXG4gIH0sXG59KTtcbiJdLCJuYW1lcyI6WyJyb3V0ZXMiLCJidWlsZFJvdXRlcyIsInNldHRpbmdzIiwicGF0aCIsInJlY29yZHMiLCJzdWJtaXNzaW9uc0J1aWxkZXJWMiIsInByb3BlcnR5RGF0YSIsImVkaXRTZWN0aW9uIiwidXNlcnNTZXR0aW5ncyIsInRlYW1TZXR0aW5ncyIsInB1YmxpY1VzZXJzU2V0dGluZ3MiXSwibWFwcGluZ3MiOiI7Ozs7K0JBRWFBOzs7ZUFBQUE7Ozt1QkFGZTtBQUVyQixNQUFNQSxTQUFTQyxJQUFBQSxrQkFBVyxFQUFDO0lBQ2hDQyxVQUFVO1FBQ1JDLE1BQU07SUFDUjtJQUNBQyxTQUFTO1FBQ1BELE1BQU07SUFDUjtJQUNBRSxzQkFBc0I7UUFDcEJGLE1BQU07SUFDUjtJQUNBRyxjQUFjO1FBQ1pILE1BQU07SUFDUjtJQUNBSSxhQUFhO1FBQ1hKLE1BQU07SUFDUjtJQUNBSyxlQUFlO1FBQ2JMLE1BQU07SUFDUjtJQUNBTSxjQUFjO1FBQ1pOLE1BQU07SUFDUjtJQUNBTyxxQkFBcUI7UUFDbkJQLE1BQU07SUFDUjtBQUNGIn0=